import {render} from 'preact';
import $ from '@modules/jquery-import';
import ReorderApp from '@containers/Reorder/';

$( () => {
    const appContainer = document.getElementById( 'reorder-app-container' );
    if ( appContainer ) {
        appContainer.classList.add( 'w-full' );
        render( <ReorderApp/>, appContainer );
    }
    else {
        console.warn( 'Could not mount <ReorderApp/> component; Root node #reorder-app-container not found' );
    }
} );




